"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var stylesImport = require("./Dialog.scss");
var styles = stylesImport;
var DialogFooter = (function (_super) {
    tslib_1.__extends(DialogFooter, _super);
    function DialogFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFooter.prototype.render = function () {
        return (React.createElement("div", { className: Utilities_1.css('ms-Dialog-actions', styles.actions) },
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-actionsRight', styles.actionsRight) }, this._renderChildrenAsActions())));
    };
    DialogFooter.prototype._renderChildrenAsActions = function () {
        return React.Children.map(this.props.children, function (child) {
            return React.createElement("span", { className: Utilities_1.css('ms-Dialog-action', styles.action) }, child);
        });
    };
    return DialogFooter;
}(Utilities_1.BaseComponent));
exports.DialogFooter = DialogFooter;
//# sourceMappingURL=DialogFooter.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Dialog/DialogFooter.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Dialog/DialogFooter.js
// module chunks = 1